import { app } from "../serviceLMS";

export async function fetchUserGroups(params) {
  try {
    const response = await app.get("user/api/client-api/group/user/groups", {
      params,
    });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch group data",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: error?.response?.data?.message || "Error fetching group data.",
    };
  }
}

export async function fetchMembersOfGroup(groupId, params) {
  try {
    const response = await app.get(`user/api/client-api/group/group-emps/basic-details/${groupId}`, {
      params,
    });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch user data",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: error?.response?.data?.message || "Error fetching user data.",
    };
  }
}


export async function fetchCoursesOfGroup(groupId, params) {
  try {
    const response = await app.get(`user/api/client-api/group/emp/group-courses/${groupId}`, {
      params,
    });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch course data",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: error?.response?.data?.message || "Error fetching course data.",
    };
  }
}